import { useEffect, useState } from "react";
import { Loader2, Search, X } from "lucide-react";
import { api } from "../../lib/api";
import { PersonaBadge } from "../Badges";

export const ClientPicker = ({ value, onChange, error, testPrefix = "client-picker" }) => {
  const [term, setTerm] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!term.trim()) return setResults([]);
    let alive = true;
    setLoading(true);
    const t = setTimeout(() => {
      api.get("/clients", { params: { q: term, page_size: 8 } })
        .then((r) => alive && setResults(r.data.items))
        .finally(() => alive && setLoading(false));
    }, 250);
    return () => { alive = false; clearTimeout(t); };
  }, [term]);

  if (value)
    return (
      <div className="flex items-center justify-between gap-3 rounded-[12px] border border-[#9bc1ff] bg-[#eef4ff] px-3.5 py-2.5" data-testid={`${testPrefix}-selected`}>
        <div className="min-w-0">
          <div className="truncate text-sm font-bold text-[#182235]">{value.name}</div>
          <div className="flex items-center gap-2 text-xs text-[#5b667a]"><span className="font-mono">{value.borrower_id}</span><PersonaBadge persona={value.persona} label={value.persona_label} /></div>
        </div>
        <button type="button" onClick={() => onChange(null)} className="tr-btn-light px-2.5 py-1.5 text-xs" data-testid={`${testPrefix}-clear`}><X className="h-3.5 w-3.5" /> Cambiar</button>
      </div>
    );

  return (
    <div className="relative">
      <Search className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[#5b667a]" />
      <input value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Busca por nombre, ID de cliente o ID de crédito" className="tr-input pl-10" data-testid={`${testPrefix}-input`} />
      {loading && <Loader2 className="absolute right-3.5 top-3.5 h-4 w-4 animate-spin text-[#0f5ef7]" />}
      {error && <p className="tr-field-error" data-testid="error-borrower-id">{error}</p>}
      {term.trim() && !loading && (
        <ul className="mt-2 max-h-72 overflow-auto rounded-[12px] border border-[#e8edf5] bg-white shadow-[0_16px_40px_rgba(14,22,38,0.08)]" data-testid={`${testPrefix}-results`}>
          {results.length === 0 && <li className="px-3.5 py-3 text-sm text-[#5b667a]">No se encontraron clientes</li>}
          {results.map((c) => (
            <li key={c.borrower_id}>
              <button type="button" onClick={() => onChange(c)} className="flex w-full items-center justify-between gap-3 px-3.5 py-2.5 text-left hover:bg-[#f5f8fc]" data-testid={`${testPrefix}-option-${c.borrower_id}`}>
                <span className="min-w-0 truncate text-sm font-semibold text-[#182235]">{c.name}</span>
                <span className="shrink-0 font-mono text-xs text-[#5b667a]">{c.borrower_id}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
